import { FC } from "react"
import { useTranslation } from "react-i18next"
import { TriangleIcon } from "@/assets"
import { useLoad } from "@/hooks/useLoad/useLoad"
import "./style.scss"

export const LoaderBar: FC = () => {
  const { t } = useTranslation()

  const progress = useLoad()

  return (
    <div className={"loader-bar"}>
      <div className={"loader-track"}>
        <div style={{ height: `${progress}%` }}>
          <div className={"loader-value"}>
            <TriangleIcon />
            <span>{Math.min(progress, 100)}%</span>
            <p>{t("button.loading")}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
